<template>
  <div
    ref="flashcard-view-container"
    class="flashcard-view-container"
  >
    <flashcard-header
      :answered="answered"
      :breadcrumbs="breadcrumbs"
      :category="currentFlashcardCategory"
      :flashcard="currentFlashcard"
      :show-progress="true"
      :title="title"
    />
    <flashcard
      :answered="answered"
      :answer-ids="answerIds"
      :category="currentFlashcardCategory"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      @set-answer-ids="setAnswerIds"
      @set-raw-answer-data="setRawAnswerData"
    />
    <flashcard-footer
      :allow-skipping="true"
      :answered="answered"
      :answer-ids="answerIds"
      :category="currentFlashcardCategory"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :terminology="isTerminology"
      @next-flashcard="goToNextFlashcard"
      @answer="answerFlashcard"
      @skip="skipFlashcard"
      @tag="tagFlashcard"
    />
  </div>
</template>

<script>

import Flashcard from '@components/flashcards/flashcard';
import FlashcardFooter from '@components/flashcards/footer';
import FlashcardHeader from '@components/flashcards/header';

import FlashcardViewMixin from '@/mixins/flashcardViews';
import GlobalMixin from '@/mixins/global';
import MnemonicsMixin from '@/mixins/mnemonics';
import RateLimitMixin from '@/mixins/rate-limit';

export default {
  components: { Flashcard, FlashcardFooter, FlashcardHeader },
  mixins: [FlashcardViewMixin, GlobalMixin, MnemonicsMixin, RateLimitMixin],
  computed: {
    breadcrumbs() {
      let categories = this.currentMnemonicCategory.path.split('.').map(id => this.$store.getters['categories/categories'][id]);
      let crumbs = categories.map(c => {
        return { name: c.name, route: {name: 'mnemonics#index', params: { categoryId: c.id}, query: this.currentQuery}};
      });
      let mnemonic = { name: this.currentMnemonic.title, route: {name: 'mnemonics#show', params: { categoryId: this.$route.params.categoryId, mnemonicId: this.$route.params.mnemonicId }, query: this.currentQuery}};
      let practice = { name: 'Practice', route: {}};
      crumbs.push(mnemonic);
      crumbs.push(practice);
      return crumbs;
    },
    currentFlashcardCategory() {
      if (this.currentFlashcard.id) {
        // just return first multiple choice category id
        let categories = this.currentFlashcard.categoryIds.map(id => this.$store.getters['categories/categories'][id]);
        let types = this.$store.getters['categoryTypes/multipleChoiceCategoryTypes'].map(ct => ct.id);
        return categories.find(c => types.includes(c.categoryTypeId));
      }
    },
    nextFlashcardRoute() {
      if (this.nextFlashcard) {
        return { name: 'mnemonics#flashcard', params: { categoryId: this.$route.params.categoryId, mnemonicId: this.$route.params.mnemonicId, flashcardId: this.nextFlashcard }, query: this.currentQuery };
      } else {
        return { name: 'mnemonics#show', params: { categoryId: this.$route.params.categoryId, mnemonicId: this.$route.params.mnemonicId }, query: this.currentQuery };
      }
    },
    title() {
      return this.currentMnemonic.title;
    },
  },
  watch: {
    '$route.params.flashcardId': function(id) {
      if(!this.$store.getters['flashcards/flashcards'][id]) {
        let params = { ids: [id], rateLimited: this.rateLimitingEnabled };
        this.$store.dispatch('flashcards/fetchFlashcards', params);
      }
    },
    'currentFlashcard.id': {
      immediate: true,
      handler: function(id) {
        this.resetFlashcard(id);
      },
    },
  },
  created() {
    this.$store.dispatch('flashcardStates/fetchStates', ['flashcards', 'stats']);
    let params = {};

    if (this.$route.params.mnemonicId) {
      params.mnemonicId = this.$route.params.mnemonicId;
    }
    params.rateLimited = this.rateLimitingEnabled;

    this.sessionPromise = this.$store.dispatch('flashcards/createFlashcardSession', params);
  },
  mounted() {
    this.sessionPromise.then(flashcard => {
      if (flashcard) {
        this.$router.replace({
          name: 'mnemonics#flashcard',
          params: {
            categoryId: this.$route.params.categoryId,
            mnemonicId: this.$route.params.mnemonicId,
            flashcardId: flashcard.id,
          },
          query: this.currentQuery,
        });
      } else {
        this.$router.go(-1);
      }
    }).catch(e => {
      this.$router.go(-1);
      Promise.reject(e);
    });
  },
};
</script>

<style lang='scss' scoped>
  .flashcard-view-container {
    @include flashcard-view;
  }
</style>
